import React, { useEffect, useMemo, useState } from "react";
import styles from "../AdmissionApplicationForm.module.css";
import AxiosInstance, {
  admissionLogo1,
  admissionLogo2,
} from "../../../services/Api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaIdCard } from "react-icons/fa";

const ApplicationXIIStatus = () => {
  const { id } = useParams();
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations]);

  const [applicationData, setApplicationData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ==================== INITIAL DATA FETCH ====================
  useEffect(() => {
    if (id) {
      fetchAdmissionCheck();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchAdmissionCheck = async () => {
    try {
      setLoading(true);
      const response = await AxiosInstance.post(
        "admission/viewHigherSecondryAdmission",
        { id: id },
      );
      if (response.data?.status) {
        setApplicationData(response.data.data);
      }
    } catch (error) {
      console.error("Admission check error:", error);
    } finally {
      setLoading(false);
    }
  };

  // Format date as DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return dateString;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  };
  return (
    <>
      {/* ==================== SCHOOL HEADER BANNER ==================== */}
      <div className={styles.schoolHeader}>
        <div className={styles.schoolLogoWrapper}>
          <img
            src={admissionLogo1}
            alt="School Logo"
            className={styles.schoolLogo}
          />
        </div>
        <div className={styles.schoolHeaderCenter}>
          <h2 className={styles.schoolHeaderTitle}>
            {applicationData?.school_name || t?.schoolName || "School Name"}
          </h2>
          <p className={styles.schoolHeaderSubtitle}>
            {t?.formXItoXII || "Form - XI to XII"}
          </p>
          <p className={styles.schoolHeaderSubtitle}>
            {t?.academicYear || "Academic Year"}:{" "}
            <strong>{applicationData?.academic_years || ""}</strong>
          </p>
        </div>
        <div className={styles.schoolLogoWrapper}>
          <img
            src={admissionLogo2}
            alt="School Logo"
            className={styles.schoolLogo}
          />
        </div>
      </div>

      {/* ==================== APPLICATION DETAILS CARD ==================== */}
      <div className={styles.pageWrapper}>
        <div className={styles.containerStatus}>
          <div className={styles.header}>
            <span className={styles.headerIcon}>
              <FaIdCard />
            </span>
            <h3 className={styles.headerTitle}>
              {t?.applicationDetails || "Application Details"}
            </h3>
          </div>

          {loading ? (
            <div className={styles.loadingContainer}>
              {t?.loading || "Loading..."}
            </div>
          ) : (
            <div className={styles.detailsGrid}>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>{t?.date || "Date"}</span>
                <span className={styles.detailValue}>
                  : {formatDate(applicationData?.date)}
                </span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {t?.applicationId || "Application Number"}
                </span>
                <span className={styles.detailValue}>
                  : {applicationData?.application_no || ""}
                </span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {t?.studentName || "Student Name"}
                </span>
                <span className={styles.detailValue}>
                  : {applicationData?.applicant_name || ""}
                </span>
              </div>
              <div className={styles.detailRow}>
                <span className={styles.detailLabel}>
                  {t?.status || "Status"}
                </span>
                <span className={styles.detailValue}>
                  : {applicationData?.status || t?.submitted || ""}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ApplicationXIIStatus;
